import React, { useEffect, useState } from "react";
import { IoMdArrowDropdown } from "react-icons/io";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import IndianFlag from "../../../assets/icons/India.webp";
import { useAppSelector, checkUserNameExists } from "@hypexone/uicore";
import { USERNAME_REGEX } from "../Payments/commonutils";
import { SVLS_API_CLIENT } from "../../../App.utils";
import Button from "../../components/shared/Button/Button";

interface StepOneProps {
  otp: number;
  otpSent: boolean;
  phoneNumber: string;
  agreedToTerms: boolean;
  username: string;
  email: string;
  password: string;
  showPassword: boolean;
  setOtp: Function;
  onEmailChange: any;
  onPhoneChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onTermsChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onUsernameChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onPasswordChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  showPasswordClickHandler: Function;
  onUsernameValidityChange: (isValid: boolean) => void;
  campaignCode: string;
  onCampaignCodeChange: (val: string) => void;
}

const StepOne: React.FC<StepOneProps> = ({
  otp,
  otpSent,
  phoneNumber,
  agreedToTerms,
  username,
  password,
  showPassword,
  setOtp,
  onEmailChange,
  onPhoneChange,
  email,
  onTermsChange,
  onUsernameChange,
  onPasswordChange,
  showPasswordClickHandler,
  onUsernameValidityChange,
  campaignCode,
  onCampaignCodeChange,
}) => {
  const { langData } = useAppSelector((state) => state.cms);
  const [errorMsg, setErrorMsg] = useState<string>();
  const [otpTimer, setOtpTimer] = useState<number | undefined>(undefined);
  const [usernameSeleted, setUsernameSelected] = useState<boolean>(false);
  const checkUserExists = async (user: string) => {
    setUsernameSelected(true);
    let valid = true;
    if (user?.length < 4) {
      setErrorMsg("Username must have at least 4 characters");
      return;
    } else if (!USERNAME_REGEX.test(user)) {
      setErrorMsg("Invalid username format");
      return;
    }
    let res = await checkUserNameExists(SVLS_API_CLIENT, user?.toLowerCase());
    if (res === true) {
      setErrorMsg("Username already exists");
      valid = false;
    } else {
      setErrorMsg("");
      valid = true;
    }
    onUsernameValidityChange(valid);
  };
  useEffect(() => {
    if (usernameSeleted) {
      checkUserExists(username);
    } else {
      onUsernameValidityChange(false);
    }
  }, [username]);
  const handleOtpTimer = (time) => {
    if (time >= 0) {
      setOtpTimer(time);
      setTimeout(() => {
        handleOtpTimer(time - 1);
      }, 1000);
    } else {
      setTimeout(() => {
        setOtpTimer(undefined);
      }, 1000);
    }
  };
  const sendOTP = async () => {
    try {
      const response: any = await SVLS_API_CLIENT.post(
        `/account/v2/otp/email/?email=${email}`
      );
      if (response.status === 204) {
        handleOtpTimer(60);
      }
    } catch (err) { }
  };
  useEffect(() => {
    if (otpSent) {
      handleOtpTimer(60);
    }
  }, [otpSent]);
  return (
    <>
      {/* <div className="mt-6">
        <div className="flex gap-2.5 mt-3 text-neutral-500 text-opacity-60">
          <div className="w-[80px] p-[2px] h-[44px] flex items-center rounded-md border border-solid border-bg-grey">
            <img src={IndianFlag} />
            <div>+91</div>
            <IoMdArrowDropdown />
          </div>
          <input
            type="tel"
            id="phoneNumber"
            className="flex items-center px-3 py-2 w-full h-[44px] bg-white rounded border border-solid border-neutral-200 text-neutral-500 text-opacity-60 focus-within:outline-none focus-within:ring-2 focus-within:border-sky-200 focus-within:ring-sky-200"
            placeholder={langData?.["enter_phone_number_txt"]}
            value={phoneNumber}
            onChange={onPhoneChange}
          />
        </div>
      </div> */}
      <div className="mt-6">
        <input
          type="email"
          id="phoneNumber"
          className="flex items-center px-3 py-2 w-full h-[44px] bg-white rounded border border-solid border-neutral-200 text-neutral-500 text-opacity-60 focus-within:outline-none focus-within:ring-2 focus-within:border-sky-200 focus-within:ring-sky-200"
          placeholder={langData?.["enter_email_address"]}
          value={email}
          onChange={onEmailChange}
          disabled
        />
      </div>

      {/* OTP */}
      {/* {otpSent && (
        <div className="mt-6">
          <label htmlFor="otp" className="self-start text-neutral-500">
            {langData?.["otp"]} *
          </label>
          <div className="flex gap-2.5 mt-3 text-neutral-500 text-opacity-60">
            <input
              type="tel"
              id="otp"
              className="px-3 py-4 mt-3 w-full bg-white rounded-lg border border-solid border-neutral-200 text-neutral-500 text-opacity-60"
              placeholder={langData?.["enter_otp_txt"]}
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />
          </div>
        </div>
      )} */}

      {/* Terms Agreement */}
      <div className="flex gap-2.5 self-start mt-5 text-stone-900">
        <input
          type="checkbox"
          id="termsAgreement"
          className="flex shrink-0 w-8 h-8 bg-white rounded-lg"
          checked={agreedToTerms}
          onChange={onTermsChange}
        />
        <label htmlFor="termsAgreement" className="flex-auto text-white my-auto">
          {langData?.["terms_and_conditions_txt"]}
        </label>
      </div>

      {/* Username */}
      <div className="mt-6">
        <label htmlFor="username" className="self-start text-white">
          {langData?.["username"]}
        </label>
        <input
          type="text"
          id="username"
          className="flex items-center px-3 py-2 w-full h-[44px] bg-white rounded border border-solid border-neutral-200 text-neutral-500 text-opacity-60 focus-within:outline-none focus-within:ring-2 focus-within:border-sky-200 focus-within:ring-sky-200"
          placeholder={langData?.["enter_username_txt"]}
          value={username}
          onChange={(e) => {
            onUsernameChange(e);
            checkUserExists(e.target.value);
          }}
        />
        {errorMsg && <div className="text-red-400 text-sm">{errorMsg}</div>}
      </div>

      {/* Password */}
      <div className="mt-6">
        <label htmlFor="password" className="self-start text-white">
          {langData?.["password"]}
        </label>
        <div className="flex items-center px-3 py-2 w-full h-[44px] bg-white rounded border border-solid border-neutral-200 text-neutral-500 text-opacity-60 focus-within:outline-none focus-within:ring-2 focus-within:border-sky-200 focus-within:ring-sky-200">
          <input
            type={showPassword ? "text" : "password"}
            id="password"
            className="w-full bg-transparent border-none"
            placeholder={langData?.["enter_password"]}
            value={password}
            onChange={onPasswordChange}
          />
          <div
            className="cursor-pointer"
            onClick={() => showPasswordClickHandler()}
          >
            {showPassword ? <FaEye /> : <FaEyeSlash />}
          </div>
        </div>
      </div>
      <div className="mt-6">
        <label htmlFor="campaignCode" className="self-start  text-white font-bold">
          {langData?.["campaign_code"] || "Campaign Code"}
        </label>
        <input
          type="text"
          id="campaignCode"
          className="flex items-center px-3 py-2 w-full h-[44px] bg-white rounded border border-solid border-neutral-200 text-black-900 font-bold text-opacity-60 focus-within:outline-none focus-within:ring-2 focus-within:border-sky-200 focus-within:ring-sky-200"
          placeholder={
            langData?.["enter_campaign_code"] ?? "Enter Campaign Code"
          }
          value={campaignCode}
          onChange={(e) => onCampaignCodeChange(e.target.value)}
        />
      </div>
      {otpSent && (
        <div className="mt-6">
          <label htmlFor="otp" className="self-start text-white">
            {langData?.["otp"]} *
          </label>
          <div className="flex gap-2.5 text-white text-opacity-60">
            <input
              type="tel"
              id="otp"
              className="px-3 py-3 w-full h-[50px] bg-white rounded-lg border border-solid border-neutral-200 text-neutral-500 text-opacity-60"
              placeholder={langData?.["enter_otp_txt"]}
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />
            <Button
              type="button"
              onClick={() => {
                if (otpTimer && otpTimer > 0) return;
                sendOTP();
              }}
              disabled={!!otpTimer && otpTimer > 0}
              className={`
        w-[155px] py-3 font-semibold rounded-lg
        ${otpTimer && otpTimer > 0
                  ? "opacity-50 cursor-not-allowed bg-gray-400 text-white"
                  : "bg-secondary hover:bg-blue-700 text-white"
                }
      `}
            >
              {otpTimer && otpTimer > 0
                ? `${langData?.["resend_in_txt"]} ${otpTimer} ${langData?.["seconds"]}`
                : langData?.["send_otp"]}
            </Button>
          </div>
        </div>
      )}
    </>
  );
};

export default StepOne;
